// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back[data-v-755e48a2]{width:200px}.back svg[data-v-755e48a2]{transform:rotate(180deg)}.relative[data-v-755e48a2]{position:relative}.InnerPadding[data-v-755e48a2]{padding:32px 0 45px}.breadcrumbs[data-v-755e48a2]{margin-bottom:55px;background:transparent!important}.flex[data-v-755e48a2]{display:flex}.justify-between[data-v-755e48a2]{justify-content:space-between}.align-center[data-v-755e48a2]{align-items:center}", ""]);
// Exports
module.exports = exports;
